import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'applib-error-page',
  templateUrl: 'error-page.component.html',
  styleUrls: ['error-page.component.scss'],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ErrorPageComponent {}
